export default __webpack_public_path__ + "static/media/barrel-empty-large.695a1abb.png";